import $ from 'jquery'

import { initVideoPlayer, destroyVideoPlayer } from 'video/videoJsPlayer'
import 'video/videoChapters'

export function initTutorialSections($section) {
  if ($section.find('.text-format').length) {
    SOPHIA.initMarkup($section);
  }

  if ($('audio', $section).length) {
    SOPHIA.initAudio($section.find('audio'))
  }
  else if ($section.hasClass('pdf_section')) {
    $section.pdfSectionsShow()
  }
  else if ($section.hasClass('video_section')) {
    $('video', $section).each((_, videoEl) => {
      initVideoPlayer(videoEl)
    })
    $('.video-chapters', $section).videoChapters();
  }
}

export function destroyTutorialSection($section) {
  if ($section.hasClass('video_section')) {
    $('video', $section).each((_, videoEl) => {
      destroyVideoPlayer(videoEl)
    })
  }
}
